export type MunicipioOption = {
  codigo_municipio: string | number;
  nome_municipio: string;
  codigo_uf?: string | number;
  sigla_uf?: string;
};

const normalizeText = (value: unknown) =>
  String(value ?? "")
    .trim()
    .toUpperCase();

const hasValue = (value: unknown) =>
  value !== undefined && value !== null && value !== "";

/** Preenche municipio_endereco quando a cidade já está no draft mas o código não foi salvo. */
export function resolveMunicipioEnderecoCode(
  draft: Record<string, unknown>,
  municipios?: MunicipioOption[],
): string | number | null {
  if (hasValue(draft.municipio_endereco)) {
    return draft.municipio_endereco as string | number;
  }

  const cidade = normalizeText(draft.endereco_cidade);
  if (!cidade) {
    return null;
  }

  const birthCity = normalizeText(draft.municipionascimento);
  if (birthCity === cidade && hasValue(draft.codigo_municipionascimento)) {
    return draft.codigo_municipionascimento as string | number;
  }

  if (!municipios?.length) {
    return null;
  }

  const uf = normalizeText(draft.endereco_estado);
  const match = municipios.find((row) => {
    if (normalizeText(row.nome_municipio) !== cidade) {
      return false;
    }
    if (!uf) {
      return true;
    }
    const rowUf = normalizeText(row.sigla_uf ?? row.codigo_uf);
    return rowUf === uf;
  });

  return match?.codigo_municipio ?? null;
}

export function hasMunicipioEnderecoValue(draft: Record<string, unknown>) {
  return (
    hasValue(draft.municipio_endereco) ||
    resolveMunicipioEnderecoCode(draft) !== null
  );
}
